import { infiniteQueryOptions, queryOptions } from "@tanstack/react-query";

import { ProjectHeaderName } from "@/api/ApiClientProvider";
import { useApi } from "@/api/hooks/useApi";
import { commonAPIDataSelector } from "@/helpers/Network/selectors";
import { useProjectId } from "@/hooks/Network/useProjectId";
import { QUERY_KEYS } from "@/query-keys";

export const useBuildingQueries = () => {
  const projectId = useProjectId();
  const api = useApi();

  return {
    listInfinite: () => {
      const limit = 25;

      return infiniteQueryOptions({
        initialPageParam: 0,
        queryKey: QUERY_KEYS.BUILDING_LIST_INFINITE(projectId),
        queryFn: ({ pageParam = 0 }) =>
          api
            .getBuildingsV1({
              Offset: pageParam * limit,
              Limit: limit,
            })
            .then((res) => commonAPIDataSelector(res)),
        getNextPageParam: (lastPage, pages) => (lastPage?.hasMore ? pages?.length : undefined),
        staleTime: 5000,
      });
    },
    list: (params?: { limit?: number; projectId?: string }) => {
      const amount = params?.limit ?? 10000;
      const requestedProjectId = params?.projectId ?? projectId;

      return queryOptions({
        queryKey: QUERY_KEYS.BUILDING_LIST(requestedProjectId, amount),
        queryFn: () =>
          api.getBuildingsV1(
            { Limit: amount },
            params?.projectId ? { headers: { [ProjectHeaderName]: params.projectId } } : undefined,
          ),
        select: commonAPIDataSelector,
      });
    },
    details: ({ buildingId }: { buildingId: string }) =>
      queryOptions({
        queryKey: QUERY_KEYS.BUILDING_DETAILS(projectId, buildingId),
        queryFn: () => api.getBuildingsDetailsV1(buildingId),
        select: commonAPIDataSelector,
      }),
  };
};
